module.exports = __webpack_public_path__ + "img/0005.d4a336b8.jpg";